import * as logger from "./logger";
// eslint-disable-next-line import/no-default-export
export default logger;
